import { render, staticRenderFns } from "./CardModelDetails.vue?vue&type=template&id=3a1d8f20&"
import script from "./CardModelDetails.vue?vue&type=script&lang=js&"
export * from "./CardModelDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports